import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Image from '../../../components/AppImage';

const JobCard = ({ job, onDelete, redirectTo }) => {
const [isAutoApplyEnabled, setIsAutoApplyEnabled] = useState(job?.autoApplyEnabled || false);

 

const getMatchColor = (percentage) => {
if (percentage >= 90) return 'text-success bg-success/10';
if (percentage >= 75) return 'text-primary bg-primary/10';
if (percentage >= 60) return 'text-warning bg-warning/10';
return 'text-text-secondary bg-muted';
};

const formatSalary = (min, max) => {
const format = (value) => {
if (value >= 1_000_000) return `$${(value / 1_000_000).toFixed(1)}M`;
if (value >= 1_000) return `$${(value / 1_000).toFixed(0)}k`;
return `$${value}`;
};

return `${format(min)} - ${format(max)}`;
};

const formatDate = (dateString) => {
const date = new Date(dateString);
const now = new Date();
const diffTime = Math.abs(now - date);
const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

if (diffDays === 1) return '1 day ago';
if (diffDays < 7) return `${diffDays} days ago`;
if (diffDays < 30) return `${Math.ceil(diffDays / 7)} weeks ago`;
return date?.toLocaleDateString();
};

return (
<div className="bg-card border border-border rounded-lg p-6 hover:shadow-elevation-2 spring-transition">
{/* Header */}
<div className="flex items-start justify-between mb-4">
<div className="flex items-start space-x-3 flex-1">
<div className="w-12 h-12 rounded-lg overflow-hidden flex-shrink-0 bg-muted">
<Image 
src={job?.companyLogo} 
alt={`${job?.company} logo`}
className="w-full h-full object-cover"
/>
</div>
<div className="flex-1 min-w-0">
<h3 className="text-lg font-semibold text-text-primary mb-1 line-clamp-2">
{job?.title}
</h3>
<p className="text-text-secondary font-medium mb-1">{job?.company}</p>
<div className="flex items-center text-sm text-text-secondary space-x-4">

<div className="flex items-center space-x-1">
<Icon name="MapPin" size={14} />
<span>{job?.location}</span>
</div>

<div> | </div>

<div className="flex items-center space-x-1">
<span>Posted: {formatDate(job?.postedDate)}</span>
</div>

<div> | </div>

<div className="flex items-center space-x-1 text-text-secondary">
<Icon name="DollarSign" size={14} />
<span>{formatSalary(job?.salaryMin, job?.salaryMax)}</span>
</div>

<div> | </div>

<div className="flex items-center space-x-1 capitalize text-text-secondary">
<Icon name="Briefcase" size={14} />
<span>{job?.experienceLevel}</span>
</div>

</div>
</div>
</div>

{/* Match Percentage */}
<div className={`px-3 py-1 rounded-full text-sm font-medium ${getMatchColor(job?.matchPercentage)}`}>
{job?.matchPercentage}% match
</div>
</div>
{/* Job Details */}
<div className="mb-4">


{/* Job Description Preview */}
<p className="text-sm text-text-secondary line-clamp-2 mb-3">
{job?.description}
</p>

{/* Skills/Tags */}
<div className="flex flex-wrap gap-2 mb-4">
{job?.skills?.slice(0, 4)?.map((skill, index) => (
<span 
key={index}
className="px-2 py-1 bg-muted text-text-secondary text-xs rounded-md"
>
{skill}
</span>
))}
{job?.skills?.length > 4 && (
<span className="px-2 py-1 bg-muted text-text-secondary text-xs rounded-md">
+{job?.skills?.length - 4} more
</span>
)}
</div>
</div>
{/* Actions */}
<div className="flex items-center justify-end pt-4 border-t border-border">
<div className="flex items-center space-x-3">

<Button
variant="outline"
size="sm"
iconName="Eye"
iconPosition="left"
iconSize={16}
onClick={() => redirectTo('/job-details/'+job?.jobPostId)} 
>
View Details
</Button>

<Button
variant="destructive"
size="sm"
onClick={() => onDelete(job?.id)}
iconName="Trash"
iconPosition="left"
iconSize={16}
>
Remove
</Button>

</div>


</div>

</div>
);
};

export default JobCard;